import { FormikProps } from "formik";
import { V3Select } from "../Select";
import { V3TextInput } from "../TextInput/V3TextInput";
import { ItemCreatedSourceTooltip, ItemToCreateSourceTooltip } from "../ReusableStyledComponents/ItemCreatedSourceToolip";
import { SourceValidator, UrlParser } from "@authory-packages/core";
import { getInputNamePlaceholder } from "../V3ModalUniversalAddContent/AddSource/AddSource.utils";

export interface SourcePickerFormik {
    sourceSlug?: string;
    newSource: boolean;
    name?: string;
}

export type SourcePickerProps<T extends SourcePickerFormik = SourcePickerFormik> = {
    formik: FormikProps<T>;
    isAddContentFlow: boolean;
    allowCreateNewSource: boolean;
    sourcesOptions: { value: string; text: string | null }[];
    actionSubmitting: boolean;
    pageUrl?: string;
};

export const SourcePicker = <T extends SourcePickerFormik>({
    formik,
    isAddContentFlow,
    allowCreateNewSource,
    sourcesOptions,
    actionSubmitting,
    pageUrl
}: SourcePickerProps<T>) => {
    let placeholder = "";

    if (pageUrl) {
        try {
            const domain = UrlParser.extractDomain(pageUrl);
            const sourceType = SourceValidator.getSourceTypeFromDomain(domain || "");

            placeholder = getInputNamePlaceholder(sourceType);
        } catch {}
    }

    const tooltip = isAddContentFlow ? <ItemToCreateSourceTooltip /> : <ItemCreatedSourceTooltip />;
    const doesntHaveSources = !sourcesOptions.length;

    return (
        <>
            {!formik.values.newSource ? (
                <V3Select
                    tooltipContent={tooltip}
                    tooltipMaxWidth={270}
                    disabledOption="Select a source"
                    name="sourceSlug"
                    label="Source"
                    disabled={!isAddContentFlow || actionSubmitting}
                    placeholder="Select a source"
                    value={formik.values.sourceSlug}
                    onChange={formik.handleChange}
                    options={sourcesOptions}
                    actionText={allowCreateNewSource ? "New source" : undefined}
                    actionClickHandler={() => formik.setFieldValue("newSource", true)}
                    error={
                        formik.errors.hasOwnProperty("sourceSlug") && formik.touched.hasOwnProperty("sourceSlug")
                            ? (formik.errors.sourceSlug as string)
                            : undefined
                    }
                />
            ) : (
                <V3TextInput
                    tooltipContent={tooltip}
                    tooltipMaxWidth={isAddContentFlow ? 300 : 255}
                    label="Source"
                    name="name"
                    width={"100%"}
                    placeholder={placeholder}
                    disabled={!isAddContentFlow || actionSubmitting}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.name}
                    actionText={doesntHaveSources ? undefined : "Existing source"}
                    actionClickHandler={() => formik.setFieldValue("newSource", false)}
                    error={formik.errors.hasOwnProperty("name") && formik.touched.hasOwnProperty("name") ? (formik.errors.name as string) : undefined}
                />
            )}
        </>
    );
};
